export const notFoundRoute = {
  path: "*",
  lazy: () => import("src/admin/not-found/not-found.tsx"),
};
